import { showToast } from '../../collections/CollectionUI.js';

/**
 * Standardized error handling helper for the collections dashboard.
 */
export class ErrorHandler {
    /**
     * Handle an error by logging it (in dev) and displaying a user-facing toast.
     *
     * @param {Error|string} error - Error instance or message to surface.
     * @param {string} userMessage - Localized message to show users.
     * @param {('error'|'warning'|'success'|'info')} [level='error'] - Toast level.
     */
    static handle(error, userMessage, level = 'error') {
        if (process.env.NODE_ENV !== 'production') {
            console.error('[CollectionsDashboard]', error);
        }

        showToast(level, userMessage);
    }

    /**
     * Unwrap an error-like value into a human readable string.
     *
     * @param {unknown} errorValue - Value caught from try/catch.
     * @returns {string}
     */
    static extractMessage(errorValue) {
        if (errorValue instanceof Error) {
            return errorValue.message || 'Unexpected error';
        }

        if (typeof errorValue === 'string') {
            return errorValue;
        }

        try {
            return JSON.stringify(errorValue);
        } catch (serializationError) {
            if (process.env.NODE_ENV !== 'production') {
                console.error('Failed to serialize error payload', serializationError);
            }
            return 'Unexpected error';
        }
    }
}
